import { ComponentType } from 'react'
import PlacesUsers from '././placesUsers'
import RecurringSend from './RecurringSend'
import UnifiedSend from './UnifiedSend'
import advertisements from './advertisements'
import appArt from './appArt'
import homeCarousel from './homeCarousel'
import attendantUsers from './attendantUsers'
import Attendants from './attendants'
import BillingAlert from './billingAlert'
import ExpirationAlert from './expirationAlerts'
import NegativeBalanceAlert from './negativeBalanceAlerts'
import Billings from './billings'
import SkippedBillings from './skippedBillings'
import BillingsPayment from './billingsPayment'
import City from './city';
import Chains from './chains'
import Clients from './clients'
import CompaniesWithoutPoints from './companiesWithoutPoints'
import CouponRefund from './couponRefund'
import CustomerGroup from './customerGroup'
import discounts from './discounts'
import scorings from './scorings'
import DispatchMessage from './dispatchMessage'
import DrawingRule from './drawing-rules'
import Drawings from './drawings'
import ExternalPartners from './externalPartners'
import ExternalPaymentMethods from "./externalPaymentMethods"
import Fillins from './fillins'
import FuelScheduledDiscounts from './fuelScheduledDiscounts'
import Fuels from './fuels'
import GroupRule from './groupRules'
import MarketingCampaigns from './marketing'
import Messages from './messages'
import News from './news'
import ParentFuels from './parentFuels'
import Partners from './partners'
import Payments from './payments'
import pendingPoints from './pendingPoints'
import PermissionGroups from './permissionGroups'
import Permissions from './permissions'
import LimitNumberFillin from './pointRules/limitNumberFillin'
import PointFillinInterval from './pointRules/pointFillinInterval'
import PointLimit from './pointRules/pointLimit'
import PopUpEdit from './popUps'
import PotencialFraud from './potencialFraud'
import MoneyProducts from './moneyProducts'
import Products from './products'
import ProductsCategory from './productsCategory'
import Profiles from './profiles'
import promoters from './promoters'
import Ratings from './ratings'
import Retailers from './retailers'
import SaleProducts from './saleProducts'
import Services from './services'
import settings from './settings'
import StationGroups from './stationGroups'
import Stations from './stations'
import InchargeStations from './inchargeStations'
import WhatsappNumbers from './whatsappNumbers'
import ChargeSessionsReport from './chargeSessionsReport'
import StoresRating from './storesRatings'
import Tag from "./tag"
import UnredeemCoupon from './unredeemCoupon'
import Users from './users'
import ValidateCoupon from './validateCoupon'
import systemUsers from './systemUsers'
import ratingPollItems from './ratingPollItems'
import Gifts from './gifts'
import Boloes from './boloes'
import Roletas from './roletas'
import Plans from './plans'
import BulkSends from './bulkSend'
import generateConfirmationQrcode from './generateConfirmationQrcode'
import attendantGoalBoards from './attendantGoalBoards'
import attendantGoalOffers from './attendantGoalOffers'
import devRequests from './devRequests'
import attendantGoalWorkerRuns from './attendantGoalWorkerRuns'
import AppLabelEdit from './AppLabels'
import ClientBills from './clientBills'
import CustomerRecoveryRules from './customerRecoveryRules'
import ChangeLog from './change-log'
import AppReleases from './app-releases'

export interface Resource {
  name: string
  permissions: string[]
  list?: ComponentType
  create?: ComponentType
  edit?: ComponentType
  show?: ComponentType
  icon?: ComponentType
  options?: { label: string }
  hasShow: boolean
  hasEdit: boolean
}

export default [
  AppLabelEdit,
  SkippedBillings,
  Chains,
  Users,
  PlacesUsers,
  City,
  Clients,
  Partners,
  Products,
  MoneyProducts,
  Stations,
  InchargeStations,
  WhatsappNumbers,
  ChargeSessionsReport,
  ValidateCoupon,
  CouponRefund,
  UnredeemCoupon,
  ExternalPartners,
  Messages,
  News,
  PopUpEdit,
  Profiles,
  PotencialFraud,
  ProductsCategory,
  Permissions,
  PermissionGroups,
  UnifiedSend,
  RecurringSend,
  DispatchMessage,
  CustomerGroup,
  GroupRule,
  pendingPoints,
  SaleProducts,
  ParentFuels,
  Fuels,
  StationGroups,
  Fuels,
  Ratings,
  StoresRating,
  Fillins,
  Services,
  Attendants,
  Payments,
  FuelScheduledDiscounts,
  CompaniesWithoutPoints,
  Drawings,
  BillingAlert,
  ExpirationAlert,
  NegativeBalanceAlert,
  Billings,
  BillingsPayment,
  MarketingCampaigns,
  DrawingRule,
  LimitNumberFillin,
  PointLimit,
  PointFillinInterval,
  Retailers,
  Tag,
  ExternalPaymentMethods,
  promoters,
  settings,
  discounts,
  scorings,
  attendantUsers,
  advertisements,
  homeCarousel,
  systemUsers,
  ratingPollItems,
  Gifts,
  Boloes,
  Roletas,
  Plans,
  BulkSends,
  generateConfirmationQrcode,
  attendantGoalBoards,
  attendantGoalOffers,
  devRequests,
  attendantGoalWorkerRuns,
  CustomerRecoveryRules,
  ClientBills,
  ChangeLog,
  AppReleases,
  appArt,
] as Resource[]
